export default "__VITE_ASSET__9f494ffe__"